import React from 'react';
import { Box, CircularProgress } from '@mui/material';

type LoadingProps = {
  height?: string;
  children?: React.ReactNode;
};

export const Loading: React.FC<LoadingProps> = ({ height, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: height || '100vh',
        width: '100%',
      }}
    >
      <CircularProgress />
      {children && <Box mb={1}>{children}</Box>}
    </Box>
  );
};
